import { useCallback } from 'react'
import styled from 'astroturf/react'
import { TagText } from '@calendly/tags'

import { DELIMITER_CHARS } from 'components/enter_details/fields/guest/constants'
import { useI18n } from 'locales'
import _EmailInput from "edit_view-EmailInput.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/fields/guest/tag/edit_view.js?styleId=EmailInput";


const EmailInput = /*#__PURE__*/styled('input', null, {
  displayName: "EmailInput",
  styles: _EmailInput
})

const EditView = ({
  name,
  onChange,
  toggleView
}) => {
  const { i18n } = useI18n()
  const handleInput = useCallback(({ target: { value } }) => {
    if (!value) toggleView()

    onChange(value)
  }, [onChange, toggleView])

  const handleFocus = useCallback(({ target }) => {
    target.select()
  }, [])

  const handleBlur = useCallback(({ target: { value } }) => {
    toggleView()
    onChange(value)
  }, [onChange, toggleView])

  const handleBeforeInput = useCallback((event) => {
    if (DELIMITER_CHARS.indexOf(event.data) > -1) {
      event.preventDefault()
      toggleView()
    }
  }, [toggleView])

  const handleMouseDown = useCallback((event) => {
    // avoid processing mouseDown on the outer TagContainer
    // which would otherwise focus TagInput
    event.stopPropagation()
  }, [])

  return (
    <>
      <TagText>{name}</TagText>
      <EmailInput
        autoFocus
        type="email"
        aria-label={i18n.t('booking.templates.email')}
        spellCheck={false}
        onChange={() => {}}
        onBlur={handleBlur}
        onMouseDown={handleMouseDown}
        onFocus={handleFocus}
        onInput={handleInput}
        onBeforeInput={handleBeforeInput}
        value={name}
      />
    </>
  )
}

export default EditView
